
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExtendedPropertyList.html?raw';
import on from 'dojo/on';


import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import StaticTable from "../../moreCore/UI/StaticTable/StaticTable";
import EntityStore from '../../moreCore/Tools/EntityStore';
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import DateTimeInput from '../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../moreCore/UI/Edit/Edit';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import Multiselect from '../../moreCore/UI/Multiselect/Multiselect';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import Button from '../../moreCore/UI/Button/Button';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import { ColorHelpers, EntityHelpers, FileHelpers, HtmlHelpers, StringHelpers, ToasterHelpers, TranslationHelpers } from "../../more/Helpers";
import { SelectEntityDialogTypes, SelectEntityDialog } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ExtendedProperties } from "./ExtendedPropertyTypes";



interface PropertyReg<T, Y> {
    input?: MdsLax<InstanceType<typeof _StatefulBase>>,
    store?: MdsLax<InstanceType<typeof EntityStore<Y>>>
    diffData?: EntityStoreData<Y>,
    cell: StaticTable.StaticTableCell<ExtendedProperties.PropertyAssignment<T>>
}

interface PropertyFilesReg {
    ID: string,
    uploadGUID?: string,
    assignmentID: string,
    filedescriptor: Partial<ExtendedProperties.FileValueDescriptor>
}
class ExtendedPropertyList<T> extends compose(_GlobalSelectEntityDialogsMixin) {
	templateString: any = template;

    private table: MdsLax<InstanceType<typeof StaticTable<ExtendedProperties.PropertyAssignment<T>>>>
    private tableContainer: HTMLElement;
    private actionContainer: HTMLElement;
    private btnRollback: HTMLElement;
    private btnNew: HTMLElement;

    private targetEntity: T & more.EntityAPIResult = null;
    private targetEntityClassname: string = null;

    private _activeEdits: Array<string>;

    private isReadonly: boolean = false;


    private propertyInputs: Record<string, PropertyReg<T, any>> = {

    };


    private tableLayout: StaticTable.Layout = {
        name: "def",
        label: "General_Default",
        rows: [{
            attributes: ["ref_vt_extended_property.description", "value_display"/*, "ref_vt_extended_property.$property_type"*/],
            colNamesInternal: ["propertyDescription", "value_display"/*, "ref_vt_extended_property.$property_type"*/],
            headings: ["ExtendedProperty_Label__Property", "ExtendedProperty_Label__Value"/*, "ExtendedProperty_Label__Type"*/],
            widths: ["40ch"],
            bgColors: ["ref_vt_extended_property.coloration"],
            txtColors: ["ref_vt_extended_property.coloration"],
            colorationStyle:"bottom"
        }]

    };

    private store: MdsLax<InstanceType<typeof EntityStore<ExtendedProperties.PropertyAssignment<T>>>>

    //private _onClick_EditRow(group: StaticTable.StaticTableRowGroup<ExtendedProperties.PropertyAssignment<T>>) {
    private _onEditRow(group: StaticTable.StaticTableRowGroup<ExtendedProperties.PropertyAssignment<T>>) {
        let entity = group.entity;

        let cell = this.table.getCell(group.rowIndex, "value_display");

        if (cell) {
            this._activeEdits.push(entity.ID);
            //this.disableNode(cell, false);
            let element = this.createInputForPropertyType(cell);
        }

        this.table.enableActionButton("edit", group.entity, false, false);

    }
    private _tableFormatter(cell: StaticTable.StaticTableCell<ExtendedProperties.PropertyAssignment<T>>) {
        let assignment = cell.entity;
        let colname = cell.name;
        let value = cell.value;



        switch (colname) {
            case "propertyDescription":

                this.UiModder.domConstruct.create("p", {
                    innerHTML: value,
                    className: "bold noMargin"
                }, cell.contentnode, "only");

                if (assignment.ref_vt_extended_property?.description_long) {
                    this.UiModder.domConstruct.create("pre", {
                        innerHTML: assignment.ref_vt_extended_property.description_long,
                        className: "noMargin noPadding smallerFont transparent"
                    }, cell.contentnode);
                }
                if (assignment.is_mandatory && !assignment.value_display) {
                    cell.bgColor = "red";
                }
                // this.UiModder.domConstruct.create("p", {
                //    innerHTML: assignment.ref_vt_extended_property?.$property_type,
                //    className: "noMargin smallerFont"
                //}, cell.contentnode);

                return true;
                break;

            case "value_display":

                if (this.store.isEntityNew(assignment)) return true; // nicht reinpfuschen, da wird gerade was neu angelegt und ein Control eingefügt.

                switch (assignment.ref_vt_extended_property?.property_type) {
                    case ExtendedProperties.Type.date:
                        value = this.dateToString(assignment.value_date);
                        cell.contentnode.innerHTML = value;
                        return true;
                        break;
                    case ExtendedProperties.Type.datetime:
                        value = this.dateToString(assignment.value_date, "dd.MM.yyyy HH:mm");
                        cell.contentnode.innerHTML = value;
                        return true;

                    case ExtendedProperties.Type.string:
                    case ExtendedProperties.Type.string_long:
                    case ExtendedProperties.Type.number:
                        return false;
                        break;

                    case ExtendedProperties.Type.bool:
                        cell.value = assignment.value_bool;
                        switch (cell.value) {
                            case true:
                                cell.contentnode.innerHTML = TranslationHelpers.translate("General_Label_Yes");
                                HtmlHelpers.createFontawesomeIcon("fas fa-check-circle", "right", cell.contentnode, "first");
                                break;
                            case false:
                                cell.contentnode.innerHTML = TranslationHelpers.translate("General_Label_No");
                                HtmlHelpers.createFontawesomeIcon("far fa-times-circle", "right", cell.contentnode, "first");
                                break;
                            default:
                                cell.contentnode.innerHTML = TranslationHelpers.translate("General_Label_Undefined");
                                HtmlHelpers.createFontawesomeIcon("far fa-question-circle", "right", cell.contentnode, "first");
                                break;
                        }

                        return true;
                        break;

                    case ExtendedProperties.Type.filterlistvalue:
                        if (assignment.ref_vt_extended_property.entity_coloration_attribute) {

                            let newContent = this.UiModder.domConstruct.create("p", {
                                innerHTML: value,
                                className: "coloredElement"
                            }, cell.contentnode, "only");

                            let entityAssignment = assignment as ExtendedProperties.PropertyAssignment_EntityValue<T, any>;
                            let colorvalue = EntityHelpers.getComplexProperty(entityAssignment.value_entity, assignment.ref_vt_extended_property.entity_coloration_attribute);

                            ColorHelpers.colorNode(newContent, colorvalue);

                            return true;
                        }
                        return false;
                    case ExtendedProperties.Type.listvalue:
                        if (assignment.ref_extended_property_value_source?.coloration) {

                            let newContent = this.UiModder.domConstruct.create("p", {
                                innerHTML: value,
                                className: "coloredElement"
                            }, cell.contentnode, "only");

                            ColorHelpers.colorNode(newContent, assignment.ref_extended_property_value_source.coloration);

                            return true;
                        }
                        return false;
                        break;

                    case ExtendedProperties.Type.filterlistvalue_multi:
                    case ExtendedProperties.Type.listvalue_multi:
                        value = "";
                        let ul = this.UiModder.domConstruct.create("ul", {}, cell.contentnode, "only");

                        for (let entry of assignment.EL_values) {
                            let li = this.UiModder.domConstruct.create("li", {
                                innerHTML: entry.value_display
                            }, ul);

                            if (entry.ref_extended_property_value_source?.coloration) {
                                ColorHelpers.colorNode(li, entry.ref_extended_property_value_source.coloration);
                            }
                        }
                        return true;
                        break;
                    case ExtendedProperties.Type.file:
                    case ExtendedProperties.Type.file_multi:




                        this._setupPropertyFiles(cell);

                        return true;
                        break;
                }
                break;
        }

        return false;
    }



    private createInputForPropertyType(cell: StaticTable.StaticTableCell<ExtendedProperties.PropertyAssignment<T>>) {

        let assignment = cell.entity;
        let property = assignment.ref_vt_extended_property;

        let label = assignment.ref_vt_extended_property.description;
        let propertyType = assignment.ref_vt_extended_property?.property_type;

        let input: MdsLax<InstanceType<typeof _StatefulBase>> = null;
        let store: MdsLax<InstanceType<typeof EntityStore<any>>> = null;
        let additionalContentAfter: HTMLElement = null;
        let additionalContentFirst: HTMLElement = null;
        let existingReg = this.propertyInputs[assignment.ID];
        if (existingReg) {
            if (existingReg.input && existingReg.input._destroyed != true) {
                input = existingReg.input;
            }


        }

        if(!input) {
            //let isMandatory = assignment. //
            switch (propertyType) {
                case ExtendedProperties.Type.date:
                    let dateInput = new DateInput();
                    //dateInput.setLabel(label);
                    dateInput.setValue(assignment.value_date, true);

                    input = dateInput;

                    break;
                case ExtendedProperties.Type.datetime:
                    let dateTimeInput = new DateTimeInput();
                    //dateTimeInput.setLabel(label);
                    dateTimeInput.setValue(assignment.value_date, true);

                    input = dateTimeInput;
                    break;
                case ExtendedProperties.Type.bool:
                    let cb = new CheckBox();
                    //dateTimeInput.setLabel(label);
                    cb.setType(assignment.ref_vt_extended_property.is_mandatory ? "checkbox" : "tristateQuestion");
                    cb.setValue(assignment.value_bool);
                    //cb.setLabel(assignment.ref_vt_extended_property.description);

                    input = cb;
                    break;

                case ExtendedProperties.Type.string:
                case ExtendedProperties.Type.string_long:
                    let strInput = new Edit();
                    //strInput.setLabel(label);
                    strInput.setIsMultiline(propertyType == ExtendedProperties.Type.string_long);
                    strInput.setValue(assignment.value_text, true);

                    input = strInput;
                    break;

                case ExtendedProperties.Type.number:
                    let numberInput = new NumberInput();
                    //numberInput.setLabel(label);

                    if (typeof (property.value_min) == "number") numberInput.setMinRange(property.value_min);
                    if (typeof (property.value_max) == "number") numberInput.setMaxRange(property.value_max);
                    if (typeof (property.value_precision) == "number") numberInput.setPlaces(property.value_precision);


                    numberInput.setValue(assignment.value_double, true);

                    input = numberInput;
                    break;

                case ExtendedProperties.Type.filterlistvalue:
                    let filterinput = new HintBox();
                    filterinput.enableSelectEntityDialog(true);

                    filterinput.setCallfunction("Webtool_API_ExtendedPropertyAssignment__Hintbox_GetResult");
                    filterinput.addAdditionalRequestParameter("propertyID", assignment.ref_vt_extended_property.ID);
                    filterinput.addAdditionalRequestParameter("assignmentID", assignment.ID);
                    //filterinput.setJsonRequestFormat("jsonData");
                    filterinput.searchParam = "searchValue";
                    if (property.entity_label_attribute) filterinput.labelAttribute = property.entity_label_attribute;
                    if (property.entity_label_attribute_secondary) filterinput.secondaryLabelAttribute = property.entity_label_attribute_secondary;
                    if (property.entity_coloration_attribute) filterinput.colorAttribute = property.entity_coloration_attribute;

                    let entityAssignment = assignment as ExtendedProperties.PropertyAssignment_EntityValue<T, any>;
                    filterinput.setValue(entityAssignment.value_entity, true);
                    filterinput.setLabel(property.description);
                    filterinput.setLabelVisibility(false);

                    input = filterinput;
                    break;

                case ExtendedProperties.Type.listvalue:
                    let searchSelect = new Multiselect();
                    searchSelect.setCyName("ExtendedPropertyList.searchSelect");
                    searchSelect.setMultiselect(false);


                    // TODO: value_double wär ja auch möglich? wie wird das entschieden?
                    searchSelect.setData(assignment.ref_extended_property_value_source?.ID,
                        assignment.ref_vt_extended_property.EL_extended_property_values,
                        true,
                        "description",
                        "ID",
                        "coloration");

                    input = searchSelect;
                    break;

                case ExtendedProperties.Type.listvalue_multi:
                    let multiselect = new Multiselect();
                    searchSelect.setCyName("ExtendedPropertyList.multiselect");

                    multiselect.setData(assignment.EL_values?.map(entry => { return entry.ref_extended_property_value_source; }),
                        property.EL_extended_property_values,
                        true,
                        "description",
                        "ID",
                        "coloration");

                    input = multiselect;
                    break;
                case ExtendedProperties.Type.filterlistvalue_multi:
                    if (!existingReg) {
                        existingReg = this._setupFilterMultiProperty(cell);
                    }
                    input = null;
                    break;

                case ExtendedProperties.Type.file:

                    if (!existingReg) {
                        existingReg = this._setupPropertyFiles(cell);
                    }

                    let fileAssignment = assignment as ExtendedProperties.PropertyAssignment_FileValue<T>;
                    // Achtung. der User soll sehen, dass schon ein File vorhanden ist und dieses ersetzt wird.
                    if (fileAssignment.EL_values?.length) {
                        additionalContentAfter = this.UiModder.domConstruct.create("div");

                        let warningContainer = this.UiModder.domConstruct.create("p", {
                            className: "warningYellowBG",
                            //innerHTML: "wird ersetzt"
                        }, additionalContentAfter);

                        let content = this.UiModder.domConstruct.create("div", {
                            "innerHTML": TranslationHelpers.translate("ExtendedPropertyAssignment_Message__FileBeingReplaced")
                        }, warningContainer);

                        let ul = this.UiModder.domConstruct.create("ul", {
                            className: "filelist"
                        }, content);

                        for (let value of fileAssignment.EL_values) {
                            let descriptor = value as any as ExtendedProperties.FileValueDescriptor;

                            this.UiModder.domConstruct.create("li", {
                                innerHTML: descriptor.filename,
                                className: "strikethrough"
                            }, ul);
                        }
                    }
                    let upload = new FileUpload(null);
                    upload.setMultiUpload(false);
                    upload.maxFileSizeKB = 8000;
                    input = upload;



                    break;

                case ExtendedProperties.Type.file_multi:
                    //let multiupload = new SimpleFileUpload();
                    //multiupload.maxSizeKB = 500;
                    //input = multiupload as any;
                    let multiupload = new FileUpload(null);
                    multiupload.setMultiUpload(true);
                    multiupload.maxFileSizeKB = 4000;
                    input = multiupload;
                    break;
            }
        }

        if (input) {
            let reg = existingReg;
            if (!existingReg) {
                reg = {
                    store: store,
                    cell: cell,
                    input: input
                };
                this.propertyInputs[assignment.ID] = reg;

            } else {

                reg.cell = cell;
                reg.input = input;
            }

            input.placeAt(cell.contentnode, "only");
            input.startup();

            if (additionalContentFirst) this.UiModder.domConstruct.place(additionalContentFirst, cell.contentnode, "first");
            if (additionalContentAfter) this.UiModder.domConstruct.place(additionalContentAfter, cell.contentnode);

            if (input.setMandatory) {
                input.setMandatory(assignment.is_mandatory == true);
            }

            if (!this.isReadonly) {
                input.on("change", lang.hitch(this, this._onChange_PropertyInput, reg, input));
            }
        }
    }

    private _onChange_PropertyInput(propertyReg: PropertyReg<T, any>) {
        let cell = propertyReg.cell;
        let assignment = cell.entity;
        let property = assignment.ref_vt_extended_property;

        let input = propertyReg.input;

        let propertyType = assignment.ref_vt_extended_property.property_type;

        let value = null;
        if( input.getValue) value = input.getValue();

        if (this.isReadonly) return;

        //let isMandatory = assignment. //
        switch (propertyType) {
            case ExtendedProperties.Type.date:
                let dateInput = input as MdsLax<InstanceType<typeof DateInput>>;
                value = this.dateToLocalISOString(dateInput.getValue().date);
                assignment.value_date = value;
                this.store.changeEntry(assignment, true);
                break;
            case ExtendedProperties.Type.datetime:
                let dateTimeInput = input as MdsLax<InstanceType<typeof DateTimeInput>>;
                value = this.dateToLocalISOString(dateTimeInput.getValue().date);
                assignment.value_date = value;
                this.store.changeEntry(assignment, true);
                break;

            case ExtendedProperties.Type.string:
            case ExtendedProperties.Type.string_long:
                assignment.value_text = value;
                this.store.changeEntry(assignment, true);
                break;

            case ExtendedProperties.Type.number:
                assignment.value_double = value;
                this.store.changeEntry(assignment, true);
                break;
            case ExtendedProperties.Type.bool:
                assignment.value_bool = value;
                this.store.changeEntry(assignment, true);
                break;

            case ExtendedProperties.Type.filterlistvalue:
                let hintbox = input as MdsLax<InstanceType<typeof HintBox>>;
                let strValue = hintbox.getValue("value");
                let entityValue = hintbox.getValue("entity") as more.EntityAPIResult;

                assignment.value_json = JSON.stringify({ "valueID": strValue, "valueClassname": entityValue?.Classname });

                (assignment as ExtendedProperties.PropertyAssignment_EntityValue<T, any>).value_entity = entityValue;
                this.store.changeEntry(assignment, true);

                break;
            case ExtendedProperties.Type.listvalue:
                let searchSelect = input as MdsLax<InstanceType<typeof Multiselect>>;
                assignment.value_json = JSON.stringify({ "valueID": value });

                value = searchSelect.getValue(true)?.[0]
                assignment.ref_extended_property_value_source = value;
                this.store.changeEntry(assignment, true);
                break;


            case ExtendedProperties.Type.listvalue_multi:
                assignment.value_json = JSON.stringify({ "valueIDs": value });
                assignment.EL_values = [];
                let multiselect = input as MdsLax<InstanceType<typeof Multiselect>>;
                for (let entry of multiselect.getValue(true)) {
                    let templ: ExtendedProperties.ValueTemplate = entry;
                    let valueAssignment: ExtendedProperties.AssignmentValue<T> = {
                        ref_vt_extended_property_assignment: null,
                        ref_extended_property_value_source: templ,
                        value_text: templ.value_text,
                        value_double: templ.value_double,
                        value_display: templ.description
                    }

                    assignment.EL_values.push(valueAssignment);
                }
                this.store.changeEntry(assignment, true);
                break;
            case ExtendedProperties.Type.filterlistvalue_multi:
                debugger;
                let filterMultiStore = propertyReg.store;
                let values = filterMultiStore.getDiffData();

                assignment.value_json = JSON.stringify(values);

                this.store.changeEntry(assignment, true);
                break;

            case ExtendedProperties.Type.file_multi:
            case ExtendedProperties.Type.file:

                let fileInput = input as MdsLax<InstanceType<typeof FileUpload>>;
                let uploads = fileInput.getUploadedFiles();

                // umwandeln ins passende Format, weil sich bestehende Files und neue Uploads einen Store teilen:
                let uploadsReg: Array<PropertyFilesReg> = [];
                for (let data of uploads) {

                    uploadsReg.push({
                        assignmentID: assignment.ID,
                        ID: data.uploadGUID + data.FileName,
                        uploadGUID: data.uploadGUID,
                        filedescriptor: {
                            filename: data.FileName,
                            extension: data.Extension,
                            filesizeKB: data.FileSize / 1024
                        }
                    });
                }


                if (property.property_type == ExtendedProperties.Type.file) {
                    // wenns nur einen Upload geben darf, muss aus dem Store alles sonstige raus
                    for (let ID of propertyReg.store.getCurrentCompleteList()) {
                        propertyReg.store.deleteEntry(ID);
                    }
                }

                // change passiert immer, auch wenn ein Eintrag nach dem Upload doch wieder entfernt worden ist
                // also erst mal alles aus "new" raus und dann nochmal rein
                let previousNewlist = propertyReg.store.getCurrentCompleteValueList("new");
                for (let ID of previousNewlist) {
                    propertyReg.store.deleteEntry(ID);
                }

                propertyReg.store.addEntries(uploadsReg);
                break;
        }
    }

    private _setupFilterMultiProperty(cell: StaticTable.StaticTableCell<ExtendedProperties.PropertyAssignment_EntityValue<T, more.EntityAPIResultExtended>>): PropertyReg<T, more.EntityAPIResultExtended> {

        let assignment = cell.entity;

        let filterMultiStore = new EntityStore<more.EntityAPIResultExtended>();
        let table = new StaticTable();

        let reg = this.propertyInputs[assignment.ID] as PropertyReg<T, more.EntityAPIResultExtended>;
        let property = cell.entity.ref_vt_extended_property;

        if (!reg) {
            reg = {
                diffData: null,
                input: null,
                store: null,
                cell: cell

            };

            this.propertyInputs[assignment.ID] = reg;

            // initiale Store-Befüllung. die zugewiesenen Werte müssen aus den Zwischen-Objekten ausglesen werden.
            if (assignment.EL_values) {
                try {
                    let entityData: Array<more.EntityAPIResultExtended> = (assignment.EL_values as Array<ExtendedProperties.AssignmentValue_Entity<T, more.EntityAPIResultExtended>>).map(entry => entry.value_entity);
                    filterMultiStore.setup(entityData);
                } catch (ex) {
                    console.warn(this.id + " error parsing value_json for entitystore", ex, assignment, property);
                }
            }

            if (!this.isReadonly) {
                let additionalContentAfter = this.UiModder.domConstruct.create("div", { className: "w3-section w3-center" });

                let addButton = this.UiModder.domConstruct.create("button", {
                    className: "buttonBase addElementBtn",
                    innerHTML: property.description
                }, additionalContentAfter);

                on(addButton, "click", lang.hitch(this, this._onClick_AddValuesForFilterMultiProperty, assignment.ID));
                on(filterMultiStore, "change", lang.hitch(this, this._onChange_PropertyInput, reg));

                table.addDefaultRowActionButton("delete");

                this.UiModder.domConstruct.place(additionalContentAfter, cell.contentnode);
            }



            table.setLayout({
                label: "",
                name: "default",
                rows: [{
                    attributes: [property.entity_label_attribute],
                    headings: [property.description]
                }]
            });
            table.setupFromStore(filterMultiStore, property.entity_label_attribute);
            table.setCyAttribute("ExtendedPropertyList");

            table.placeAt(cell.contentnode, "first");

            reg.store = filterMultiStore;
            reg.input = table as any;


        }

        return reg;
    }

    private _setupPropertyFiles(cell: StaticTable.StaticTableCell<ExtendedProperties.PropertyAssignment_FileValue<T>>): PropertyReg<T, any> {

        // wir müssen die Files in der Zelle darstellen (zum Downloaden, ggf. zum Entfernen)
        // außerdem braucht es WEGEN der Möglichkeit des Entfernens und Bearbeitens vorab schon einen eigenen Store
        // damit new und deleted Files korrekt registriert werden
        //

        let assignment = cell.entity;

        //
        //let fileDescriptors: Array<ExtendedProperties.FileDescriptor> = [];

        //for (let fileValue of assignment.EL_values) {
        //    if (fileValue.tmp_json_value_file) {
        //        try {
        //            let fileDescriptor = JSON.parse(fileValue.tmp_json_value_file) as ExtendedProperties.FileDescriptor;

        //            fileDescriptors.push(fileDescriptor);


        //        } catch (ex) {
        //            console.error(this.id + " invalid filecontent", fileValue, ex);
        //        }
        //    }
        //}


        // zuerst für das Property einen Registry-Record machen
        // die vorhandenen Files werden zu einem eigenen Interface konvertiert, damit wir später einfach neue Uploads einfügen können
        // dann kommen die in den Property-eigenen Store:
        let reg = this.propertyInputs[assignment.ID] as PropertyReg<T, PropertyFilesReg>;
        if (!reg) {
            let fileStore = new EntityStore<PropertyFilesReg>();

            let existingData: Array<PropertyFilesReg> = [];
            for (let value of assignment.EL_values) {
                if (value.tmp_json_value_file) {
                    let descriptor = JSON.parse(value.tmp_json_value_file) as ExtendedProperties.FileValueDescriptor;

                    existingData.push({
                        assignmentID: assignment.ID,
                        ID: descriptor.ID,
                        uploadGUID: null,
                        filedescriptor: descriptor
                    });
                }

                fileStore.setup(existingData, "ID");


            }

            reg = {
                diffData: null,
                input: null,
                store: fileStore,
                cell: cell

            };
            this.propertyInputs[assignment.ID] = reg;

            if (!this.isReadonly) {
                fileStore.on("change", lang.hitch(this, this._onChange_PropertyFilesStore, reg));
            }

        } else {
            // reg schon vorhanden, weil Tabelle sich neu gezeichnet hat? Zelle wechseln, rest bleibt.
            reg.cell = cell;
        }


        // die bestehenden Files zeichnen
        let container = this.UiModder.domConstruct.create("div", {
            className: "filelist flex_row flex_gapSmall"
        }, cell.contentnode, "only");

        for (let file of reg.store.getCurrentCompleteList("all")) {

            let descriptor = file.filedescriptor;

            let fileContainer = this.UiModder.domConstruct.create("div", { className: ""}, container);

            let group = this.UiModder.domConstruct.create("div", { className: "buttonGroup" }, fileContainer);

            let dlButton = new Button();
            dlButton.placeAt(group);

            dlButton.setLabel(descriptor.filename + "." + descriptor.extension, StringHelpers.formatBytes(descriptor.filesizeKB * 1024, 2));
            dlButton.setClick(lang.hitch(this, this._requestFileDownload, file, dlButton.domNode));
            dlButton.setIconLeft("fas fa-download");
            dlButton.setClasses("download");

            let bIsRemoved = reg.store.isEntityDeleted(file);

            // falls schon aus Store entfernt, markieren:
            this.UiModder.domClass.toggle(fileContainer, "strikethrough w3-disabled", bIsRemoved);


            // ansonsten Möglichkeit zum Entfernen:
            if (this.isReadonly != true && !bIsRemoved) {
                let deleteButton = new Button();
                deleteButton.placeAt(group);
                deleteButton.setClasses("delete");
                deleteButton.setIconLeft("fas fa-trash warningTXT");

                deleteButton.setClick(lang.hitch(this, this._onRemoveFile, reg, file));
            }
        }

        return reg;
    }

    private _onRemoveFile(reg: PropertyReg<T, PropertyFilesReg>, file: PropertyFilesReg) {
        reg.store.deleteEntry(file);
    }
    private _requestFileDownload(file: ExtendedProperties.FileValueDescriptor,
        node: HTMLElement) {


        let data = {
            valueID: file.ID
        };

        this.hourGlassStart(node);

        this.RequestManager.callfunction(
            "Webtool_API_ExtendedPropertyAssignment__GetFileDownload",
            data,
            lang.hitch(this, this._onFileDownloadReady, node),
            lang.hitch(this, this._onFileDownloadError, node)

        );
    }

    private _onFileDownloadReady(node: HTMLElement, response: FileFinder.FileDescriptorWithBase64) {
        this.hourGlassEnd(node);
        FileHelpers.provideFile(response, null, "filePreview/useInExtendedProperties");
    }
    private _onFileDownloadError(node: HTMLElement, error: more.requestErrorMessage) {
        this.hourGlassEnd(node);

        ToasterHelpers.showToast({
            title: "file download error",
            message: error.Message,
            iconClass: toasterIcons.error
        });

    }

    private _onChange_PropertyFilesStore(propertyReg: PropertyReg<T, PropertyFilesReg>) {

        let diffData = propertyReg.store.getDiffData();
        // Änderung an Files löst erst mal Änderung an DEREN Store aus, und dann landen wir hier und geben die Änderung an den Gesamtstore weiter:
        let assignment = propertyReg.cell.entity;
        assignment.value_json = JSON.stringify(diffData);
        propertyReg.diffData = diffData;
        this.store.changeEntry(assignment, true);
    }

    private _onClick_AddValuesForFilterMultiProperty(propertyAssignmentID: string, evt: MouseEvent) {

        let reg = this.propertyInputs[propertyAssignmentID];
        if (!reg) return;
        if (!reg.store) return;

        let propAss = reg.cell.entity;
        let property = propAss.ref_vt_extended_property;

        let SED = new SelectEntityDialog<more.EntityAPIResultExtended>();
        SED.setup(reg.cell.entity.ref_vt_extended_property.description,
            lang.hitch(this, this._onSelectValuesForFilterMultiProperty, reg),
            "Webtool_API_ExtendedPropertyAssignment__GetFilterListMultiResults",
            10,
            null,
            { maxSelect: 999, minSelect: propAss.is_mandatory ? 1 : 0 },
            property.entity_label_attribute,
            property.entity_label_attribute_secondary);

        let values = reg.store.getCurrentCompleteList();

        //SED.setValues(values); // unzuverlässig, funktioniert ned gscheid.
        SED.addRequestParameter("propertyID", reg.cell.entity.ref_vt_extended_property.ID);

        SED.show();
    }

    private _onSelectValuesForFilterMultiProperty(reg: PropertyReg<T, more.EntityAPIResult>, values: string[], items: Array<SelectEntityDialogTypes.Item<more.EntityAPIResultExtended>>) {
        let data = items.map(item => item.entry.data);
        reg.store.updateFromList(data);
    }

    private _onDataSet() {
        this.emit("dataset");
        this._activeEdits = [];
        this.propertyInputs = {};
    }

    private _onTableDrawn() {
        for (let entity of this.store.getCurrentCompleteList()) {
            if (this._activeEdits.indexOf(entity.ID) != -1 ||
                this.store.isEntityNew(entity)) {
                this._onEditRow(this.table.getRowGroupByKeyValue(entity.ID));
            }
        }

        let table = new StaticTable();
        table.setCyAttribute("ExtendedPropertyList");
    }
    private _onChange_StoreData() {

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);
        //if (this.store.isDirty()) {
        //    this._delayEmit();
        //}
        this.disableNode(this.btnRollback, !this.store.isDirty());
        this._delayEmit(); // immer emitten - dirty könnte sich ja ggf zurücksetzen

    }

    private _emitHandle: any = null;
    private _delayEmit() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.getData()), 20);

    }



    getData(): Array<ExtendedProperties.PropertyAssignment<T>> {
        return this.store.getCurrentCompleteList();
    }
    getDiffData(): EntityStoreData<ExtendedProperties.PropertyAssignment<T>> {
        let diffData = this.store.getDiffData(true);
        return diffData;
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;
        let bEdit = this.hasUserRole("EvCast_Edit");
        let bDelete = this.hasUserRole("EvCast_Delete");

        this.table = new StaticTable();

        this.table.clipContentOverflow = false;

        if (bEdit) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));

        if (bDelete) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);


        this.table.setTableLayout(this.tableLayout);
        this.table.setCyAttribute("ExtendedPropertyList");

        if (this.isReadonly != true) {
            this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onEditRow));
        }

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);

        this.table.setupFromStore(this.store);

        this.table.on("tableDrawn", lang.hitch(this, this._onTableDrawn));


    }
    private _onClick_Rollback(evt) {
        if (this.store.isDirty()) this.store.rollback();
    }
    private _onClick_AddProperty(evt) {
        let currentAssignments = this.store.getCurrentCompleteList();
        let excludedIds = currentAssignments.map(entry => entry.ref_vt_extended_property.ID);

        this.loadSelectEntityDialog(evt,
            "addProperty",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            {
                targetEntityID: this.targetEntity?.ID,
                targetEntityClassname: this.targetEntityClassname,
                excludedIDs: excludedIds
            }
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<ExtendedProperties.Property>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items || !items.length) return;

        let property = items[0].entry.data;

        // das Property im SED ist nicht "vollständig"
        // erweiterte Eigenschaften zb für verfügbare Werte etc. fehlen!

        // je nach Propertytype ist also noch ein Request für die kompletten Metadaten sinnvoll.
        switch (property.property_type) {
            // bei diesen hier ist es aber simpel genug, einfach gleich weiter ins onload:
            case ExtendedProperties.Type.date:
            case ExtendedProperties.Type.datetime:
            case ExtendedProperties.Type.string:
            case ExtendedProperties.Type.string_long:
            case ExtendedProperties.Type.file:
                //case ExtendedProperties.Type.number: // nein, weil es kann min- und max-Werte brauchen!
                this._onLoadPropertyEntityResponse(property);
                return;
                break;
        }



        this.RequestManager.callfunction(
            "Webtool_API_ExtendedPropertyAssignment__GetPropertyEntity",
            {
                ID: property.ID
            },
            lang.hitch(this, this._onLoadPropertyEntityResponse),
            lang.hitch(this, this._onLoadPropertyEntityError)
        );

        this.hourGlassStart(this.tableContainer);
    }

    private _onLoadPropertyEntityError(error: more.requestErrorMessage) {
        this.hourGlassEnd(this.tableContainer);

        ToasterHelpers.showToast({
            title: "ExtendedProperty_Title__LoadingPropertyFailed",
            message: error.Message,
            messageIcon: toasterIcons.error,
            iconClass: toasterIcons.error,
            modalSize: "smaller",
            showClose: true,
            ID: "loadingProperty"
        });
    }

    private _onLoadPropertyEntityResponse(property: ExtendedProperties.Property){

        ToasterHelpers.removeToast("loadingProperty");

        this.hourGlassEnd(this.tableContainer);

        // Stumpf anlegen:
        let assignment: ExtendedProperties.PropertyAssignment<T> = {

            ID: property.ID + "-" + StringHelpers.randomID(10),
            order: property.order,
            is_mandatory: property.is_mandatory,
            //order_2:
            ref_entity: EntityHelpers.getSimplifiedObject<T>(this.targetEntity, ["ID", "Classname"]),
            entity_classname: this.targetEntityClassname,
            ref_vt_extended_property: property,
            value_display: "",
            EL_values: []
        }

        // in den Store aufnehmen:
        let ID = this.store.addEntry(assignment, "new");

    }

    private _loadAssignmentsOfEntity() {
        this.StandbyStart();

        let data = {
            targetEntityID: this.targetEntity?.ID,
            targetEntityClassname: this.targetEntityClassname
        };

        this.RequestManager.callfunction(
            "Webtool_API_ExtendedPropertyAssignment__GetAssignmentsOfEntity",
            data,
            lang.hitch(this, this._onLoadAssignmentsResult),
            lang.hitch(this, this._onLoadAssignmentsError),

        )
    }

    private _onLoadAssignmentsResult(result: Array<ExtendedProperties.PropertyAssignment<T>>) {
        this.StandbyStop();
    }

    private _onLoadAssignmentsError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }

    setReadonly(bReadonly: boolean = true) {
        this.isReadonly = bReadonly !== false;

        this.hideNode(this.actionContainer, this.isReadonly);
    }


    setup(targetEntityClass: string, targetEntity?: T & more.EntityAPIResult, existingList?: Array<ExtendedProperties.PropertyAssignment<T>>) {

        this.targetEntity = targetEntity;
        this.targetEntityClassname = targetEntityClass;

        if (this.targetEntity && this.targetEntity["Classname"]) this.targetEntityClassname = this.targetEntity.Classname;

        this._activeEdits = [];
        if (existingList) {
            this.store.setup(existingList, "ID");
        }

        this.setupTable();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));
        this.store.on("dataset", lang.hitch(this, this._onDataSet));

        this.SEDconfigCallfunction = "Webtool_API_ExtendedPropertyAssignment__SED_GetConfig";



    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ExtendedPropertyList);
